var map = {
	"./ArticlesofAssociationorAnnualReturnhongkong.jpg": "0948",
	"./Companyoperationproofaddresshongkong.jpg": "c092",
	"./companyregistrationcertificatehongkong.jpg": "7c58",
	"./taxcertificatehongkong.jpg": "3f03"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f535";